export enum ObjectionCategory {
  DebtCollectionProcessComplaint = "Debt colletion process complaint",
  InvoiceRelatedObjection = "Invoice related objection",
}

export enum ObjectionType {
  DebtCollection = 0,
  InvoiceRelated = 1,
  Other = 2,
}

export const ObjectionCategoryTypeMapper: Record<string, ObjectionType> = {
  [ObjectionCategory.InvoiceRelatedObjection.toLowerCase()]:
    ObjectionType.InvoiceRelated,

  [ObjectionCategory.DebtCollectionProcessComplaint.toLowerCase()]:
    ObjectionType.DebtCollection,
};
